import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import {
  ConfigureAndEnableIdentityProviderMutation,
  ConfigureAndEnableIdentityProviderMutationVariables,
} from '../../../shared/generated/graphql';

export const CONFIGURE_AND_ENABLE_IDENTITY_PROVIDER = gql`
  mutation configureAndEnableIdentityProvider(
    $attribute_mapping: String!
    $idp_identifiers: [String]
    $provider_details: String!
    $provider_type: String!
    $idp_user_role_mapping: String
  ) {
    configureAndEnableIdentityProvider(
      attribute_mapping: $attribute_mapping
      idp_identifiers: $idp_identifiers
      provider_details: $provider_details
      provider_type: $provider_type
      idp_user_role_mapping: $idp_user_role_mapping
    ) {
      status_code
      body {
        data
        message
        success
      }
    }
  }
`;
export const useConfigureAndEnableIdentityProvider = (
  options: MutationHookOptions<
    ConfigureAndEnableIdentityProviderMutation,
    ConfigureAndEnableIdentityProviderMutationVariables
  >,
) => {
  return useMutation<
    ConfigureAndEnableIdentityProviderMutation,
    ConfigureAndEnableIdentityProviderMutationVariables
  >(CONFIGURE_AND_ENABLE_IDENTITY_PROVIDER, options);
};
